import { defineStore } from 'pinia';
import api from '@/api/api';
import type { ZRecommendation } from '@schemas/recommendation.schemas';

export const useRecommendationStore = defineStore('recommendation', {
    state: () => ({
        recommendation: null as ZRecommendation | null,
        recommendations: [] as ZRecommendation[],
        currentRecommendation: null as ZRecommendation | null
    }),
    actions: {
        clearMyData(): void {

        },
        async fetchRecommendation(recommendationId: string): Promise<ZRecommendation> {
            this.recommendation = this.recommendations.find(app => app._id === recommendationId) ||
                await api.getDocument<ZRecommendation>('recommendations', recommendationId);
            return this.recommendation;
        },

        async fetchRecommendations(): Promise<ZRecommendation[]> {
            this.recommendations = await api.getDocuments<ZRecommendation>('recommendations');
            return this.recommendations;
        },

        /**
         * Fetch recommendations for a specific event
         * @param eventId
         */
        async fetchRecommendationsForEvent(eventId: string): Promise<ZRecommendation[]> {
            this.recommendations = await api.getDocuments<ZRecommendation>('recommendations/event/' + eventId);
            return this.recommendations;
        },

        /**
         * Fetch recommendations for a specific announcer
         * @param announcerId
         */
        async fetchRecommendationsForAnnouncer(announcerId: string): Promise<ZRecommendation[]> {
            this.recommendations = await api.getDocuments<ZRecommendation>('recommendations/announcer/' + announcerId);
            return this.recommendations;
        },
        /**
         * Add a new recommendation
         * There is no update only post.
         * @param recommendation
         */
        async addRecommendation(recommendation: Partial<ZRecommendation>): Promise<ZRecommendation> {
            const newRecommendation = await api.postDocument<ZRecommendation>('recommendations', recommendation);
            this.recommendations.push(newRecommendation);
            return newRecommendation;
        },

        /**
         * Remove a recommendation
         * @param recommendationId
         */
        async removeRecommendation(recommendationId: string): Promise<void> {
            await api.deleteDocument<ZRecommendation>('recommendations', recommendationId);
            this.recommendations = this.recommendations.filter(recommendation => recommendation._id !== recommendationId);
        }
    }
});
